import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React from 'react';
import { useProfile } from 'src/features/auth/auth.hooks';
import { User } from 'src/features/users/users.types';
import SubMenu from 'antd/es/menu/SubMenu';

interface SubMenuProtectedProps extends MenuItemProps {
  roles: string[];
  key: string;
}

const SubMenuProtected: React.FC<SubMenuProtectedProps> = props => {
  const user = useProfile() as User;
  const { roles, children, key, ...rest } = props;

  if (roles && roles.includes(user.role)) {
    return (
      <SubMenu key={key} {...rest}>
        {children}
      </SubMenu>
    );
  }
  return <></>;
};

export default SubMenuProtected;
